<template>
  <div class="wobao-intelligent-booking-container">
    <intelligent-booking-result-multi
      v-if="dialogVisible"
      :visible="dialogVisible"
      :detail-list="detailList"
      :source="source"
      @close="handleClose"
      @success="handleSuccess"
      @copyIntelligentDocument="handleCopyIntelligentDocument"
    />
  </div>
</template>

<script>
import IntelligentBookingResultMulti from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew'

export default {
  name: 'WobaoIntelligentBookingMulti',
  components: {
    IntelligentBookingResultMulti
  },
  props: {
    detailList: {
      type: Array,
      default: () => []
    },
    source: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },

  beforeDestroy() {
    // 组件销毁时清理body类
    this.safeCleanup()
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      // 确保body有正确的类用于下拉框层级控制
      this.$nextTick(() => {
        if (!document.body.classList.contains('intelligent-booking-result-active')) {
          document.body.classList.add('intelligent-booking-result-active')
        }
      })
    },

    // 安全清理方法
    safeCleanup() {
      document.body.classList.remove('intelligent-booking-result-active')
    },

    handleClose() {
      this.dialogVisible = false
      // 清理body类
      this.safeCleanup()
      this.$emit('close')
    },

    handleSuccess() {
      console.log('覆盖系统按钮触发。')
      this.dialogVisible = false
      // 清理body类
      this.safeCleanup()
      this.$emit('success')
    },

    handleCopyIntelligentDocument(res) {
      this.$emit('copyIntelligentDocument', res)
    }
  }
}
</script>

<style scoped>
/* 沃宝智能对单容器样式 */
.wobao-intelligent-booking-container {
  z-index: 99999 !important;
  position: relative;
}

.wobao-intelligent-booking-container ::v-deep .el-dialog__wrapper {
  padding: 5vh 5vw !important;
  z-index: 99999 !important;
}

.wobao-intelligent-booking-container ::v-deep .el-dialog.intelligent-booking-result-dialog {
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
  z-index: 99999 !important;
}

/* 沃宝智能对单弹窗样式覆盖 */
.wobao-intelligent-booking-container ::v-deep .intelligent-booking-result-dialog.intelligent-booking-result-dialog {
  width: 100% !important;
  height: calc(100vh - 10vh) !important;
  max-width: 100% !important;
  max-height: calc(100vh - 10vh) !important;
  margin: 0 !important;
  min-width: auto !important;
  z-index: 99999 !important;
}

.wobao-intelligent-booking-container ::v-deep .el-dialog__header,
.wobao-intelligent-booking-container ::v-deep .el-dialog__body,
.wobao-intelligent-booking-container ::v-deep .el-dialog__footer {
  z-index: 99999 !important;
}

.wobao-intelligent-booking-container ::v-deep .v-modal {
  z-index: 99998 !important;
}

/* 确保沃宝智能对单中的下拉框和弹窗组件显示在最顶层 */
.wobao-intelligent-booking-container ::v-deep .el-select-dropdown,
.wobao-intelligent-booking-container ::v-deep .el-picker-panel,
.wobao-intelligent-booking-container ::v-deep .el-time-panel,
.wobao-intelligent-booking-container ::v-deep .el-cascader-panel,
.wobao-intelligent-booking-container ::v-deep .el-popper,
.wobao-intelligent-booking-container ::v-deep .el-tooltip__popper,
.wobao-intelligent-booking-container ::v-deep .el-autocomplete-suggestion,
.wobao-intelligent-booking-container ::v-deep .el-color-dropdown,
.wobao-intelligent-booking-container ::v-deep .el-dropdown-menu,
.wobao-intelligent-booking-container ::v-deep .el-message,
.wobao-intelligent-booking-container ::v-deep .el-message-box__wrapper,
.wobao-intelligent-booking-container ::v-deep .el-notification,
.wobao-intelligent-booking-container ::v-deep .el-dialog__wrapper,
.wobao-intelligent-booking-container ::v-deep .el-dialog {
  z-index: 100001 !important;
}

/* 全局body下的下拉框和弹窗组件层级控制 - 当沃宝容器激活时 */
body.intelligent-booking-result-active .el-select-dropdown,
body.intelligent-booking-result-active .el-picker-panel,
body.intelligent-booking-result-active .el-time-panel,
body.intelligent-booking-result-active .el-cascader-panel,
body.intelligent-booking-result-active .el-popper,
body.intelligent-booking-result-active .el-tooltip__popper,
body.intelligent-booking-result-active .el-autocomplete-suggestion,
body.intelligent-booking-result-active .el-color-dropdown,
body.intelligent-booking-result-active .el-dropdown-menu,
body.intelligent-booking-result-active .el-message,
body.intelligent-booking-result-active .el-message-box__wrapper,
body.intelligent-booking-result-active .el-notification,
body.intelligent-booking-result-active .el-dialog__wrapper,
body.intelligent-booking-result-active .el-dialog {
  z-index: 100002 !important;
}

/* 全局body下的特定弹窗层级控制 - 当沃宝容器激活时 */
body.intelligent-booking-result-active .el-dialog[no="saveAndBookingDialog"],
body.intelligent-booking-result-active .el-dialog[no="creditValidDialog"],
body.intelligent-booking-result-active .el-dialog[no="fieldValidDialog"] {
  z-index: 100004 !important;
}

body.intelligent-booking-result-active .el-dialog__wrapper[no="saveAndBookingDialog"],
body.intelligent-booking-result-active .el-dialog__wrapper[no="creditValidDialog"],
body.intelligent-booking-result-active .el-dialog__wrapper[no="fieldValidDialog"] {
  z-index: 100004 !important;
}
</style>

<style>
/* 全局样式：确保挂载到body的弹窗在沃宝智能对单激活时显示在最顶层 */
body.intelligent-booking-result-active .el-dialog[no="saveAndBookingDialog"],
body.intelligent-booking-result-active .el-dialog[no="creditValidDialog"],
body.intelligent-booking-result-active .el-dialog[no="fieldValidDialog"],
body.intelligent-booking-result-active .el-dialog[no="batchCheckingWindow"] {
  z-index: 100005 !important;
}

body.intelligent-booking-result-active .el-dialog__wrapper[no="saveAndBookingDialog"],
body.intelligent-booking-result-active .el-dialog__wrapper[no="creditValidDialog"],
body.intelligent-booking-result-active .el-dialog__wrapper[no="fieldValidDialog"],
body.intelligent-booking-result-active .el-dialog__wrapper[no="batchCheckingWindow"] {
  z-index: 100005 !important;
}

/* 确保所有挂载到body的dialog都有足够高的层级 */
body.intelligent-booking-result-active .el-dialog__wrapper[append-to-body] {
  z-index: 100005 !important;
}

body.intelligent-booking-result-active .el-dialog[append-to-body] {
  z-index: 100005 !important;
}

/* 确保蒙层也有足够高的层级，但要低于弹窗本身 */
body.intelligent-booking-result-active .v-modal {
  z-index: 100004 !important;
}

body.intelligent-booking-result-active .el-overlay {
  z-index: 100004 !important;
}

body.intelligent-booking-result-active .el-dialog__mask {
  z-index: 100004 !important;
}

body.intelligent-booking-result-active .el-loading-mask {
  z-index: 100006 !important;
}
</style>

